// import React, { useState } from 'react'
// import SimpleReactValidator from 'simple-react-validator';


// const ContactForm = () => {

//     const [forms, setForms] = useState({
//         name: '',
//         email: '',
//         subject: '',
//         phone: '',
//         message: ''
//     });
//     const [validator] = useState(new SimpleReactValidator({
//         className: 'errorMessage'
//     }));
//     const changeHandler = e => {
//         setForms({ ...forms, [e.target.name]: e.target.value })
//         if (validator.allValid()) {
//             validator.hideMessages();
//         } else {
//             validator.showMessages();
//         }
//     };

//     const submitHandler = e => {
//         e.preventDefault();
//         if (validator.allValid()) {
//             validator.hideMessages();
//             setForms({
//                 name: '',
//                 email: '',
//                 subject: '',
//                 phone: '',
//                 message: ''
//             })
//         } else {
//             validator.showMessages();
//         }
//     };

//     return (
//         <form onSubmit={(e) => submitHandler(e)} className="contact-validation-active" >
//             <div className="row">
//                 <div className="col col-lg-6 col-12">
//                     <div className="form-field">
//                         <input
//                             value={forms.name}
//                             type="text"
//                             name="name"
//                             onBlur={(e) => changeHandler(e)}
//                             onChange={(e) => changeHandler(e)}
//                             placeholder="Your Name" />
//                         {validator.message('name', forms.name, 'required|alpha_space')}
//                     </div>
//                 </div>
//                 <div className="col col-lg-6 col-12">
//                     <div className="form-field">
//                         <input
//                             value={forms.email}
//                             type="email"
//                             name="email"
//                             onBlur={(e) => changeHandler(e)}
//                             onChange={(e) => changeHandler(e)}
//                             placeholder="Your Email" />
//                         {validator.message('email', forms.email, 'required|email')}
//                     </div>
//                 </div>
//                 <div className="col col-lg-6 col-12">
//                     <div className="form-field">
//                         <input
//                             value={forms.phone}
//                             type="phone"
//                             name="phone"
//                             onBlur={(e) => changeHandler(e)}
//                             onChange={(e) => changeHandler(e)}
//                             placeholder="Your phone" />
//                         {validator.message('phone', forms.phone, 'required|phone')}
//                     </div>
//                 </div>
//                 <div className="col col-lg-6 col-12">
//                     <div className="form-field">
//                         <select
//                             onBlur={(e) => changeHandler(e)}
//                             onChange={(e) => changeHandler(e)}
//                             value={forms.subject}
//                             type="text"
//                             name="subject">
//                             <option>Subject 1</option>
//                             <option>Subject 2</option>
//                             <option>Subject 3</option>
//                         </select>
//                         {validator.message('subject', forms.subject, 'required')}
//                     </div>
//                 </div>
//                 <div className="col col-lg-12 col-12">
//                     <textarea
//                         onBlur={(e) => changeHandler(e)}
//                         onChange={(e) => changeHandler(e)}
//                         value={forms.message}
//                         type="text"
//                         name="message"
//                         placeholder="Message">
//                     </textarea>
//                     {validator.message('message', forms.message, 'required')}
//                 </div>
//             </div>
//             <div className="submit-area">
//                 <button type="submit" className="theme-btn">Submit Now</button>
//             </div>
//         </form >
//     )
// }

// export default ContactForm;

import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator'; // Thư viện kiểm tra dữ liệu

const ContactForm = () => {

    // State để lưu dữ liệu form
    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '', // Giữ nguyên tên key
        phone: '',
        message: ''
    });

    // Khởi tạo validator
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage', // Class CSS cho thông báo lỗi
        // Để có thông báo lỗi tiếng Việt, bạn cần cấu hình thêm cho SimpleReactValidator
        // Ví dụ: messages: { required: 'Trường này là bắt buộc.' , email: 'Email không hợp lệ.', ... }
        // Xem tài liệu của thư viện để biết chi tiết.
    }));

    // Xử lý khi thay đổi giá trị input
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value });
        if (validator.allValid()) {
            validator.hideMessages(); // Ẩn lỗi nếu tất cả hợp lệ
        } else {
            validator.showMessages(); // Hiện lỗi nếu có
        }
    };

    // Xử lý khi gửi form
    const submitHandler = e => {
        e.preventDefault(); // Ngăn trình duyệt gửi form theo cách mặc định
        if (validator.allValid()) { // Kiểm tra tất cả các trường hợp lệ
            validator.hideMessages();
            // --- Xử lý logic gửi form ở đây ---
            // Ví dụ: Gửi dữ liệu forms lên server hoặc API
            console.log('Form hợp lệ, gửi dữ liệu:', forms);
            // ---------------------------------
            alert('Cảm ơn bạn đã gửi liên hệ!'); // Thông báo thành công (ví dụ)
            // Reset form sau khi gửi thành công
            setForms({
                name: '',
                email: '',
                subject: '',
                phone: '',
                message: ''
            });
        } else {
            validator.showMessages(); // Hiển thị lỗi nếu form không hợp lệ
        }
    };

    return (
        // Sử dụng onSubmit ở thẻ form
        <form onSubmit={submitHandler} className="contact-validation-active">
            <div className="row">
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.name}
                            type="text"
                            name="name" // Giữ nguyên name để khớp với state và validator
                            onBlur={changeHandler} // Kiểm tra khi rời khỏi input
                            onChange={changeHandler} // Cập nhật state khi gõ
                            placeholder="Họ và Tên" // Đã đổi sang tiếng Việt
                        />
                        {/* Thông báo lỗi cho trường 'name' */}
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Email của bạn" // Đã đổi sang tiếng Việt
                        />
                        {/* Thông báo lỗi cho trường 'email' */}
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.phone}
                            type="tel" // Đổi type thành "tel" cho ngữ nghĩa tốt hơn
                            name="phone"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Số điện thoại" // Đã đổi sang tiếng Việt
                        />
                        {/* Thông báo lỗi cho trường 'phone' - rule 'phone' có thể cần custom */}
                        {validator.message('phone', forms.phone, 'required|phone')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <select
                            // Đặt giá trị mặc định cho subject trong state là ''
                            value={forms.subject}
                            onChange={changeHandler} // Không cần onBlur cho select thường
                            name="subject"
                            // Thêm một giá trị mặc định và yêu cầu chọn chủ đề
                            className={!forms.subject ? 'default-option' : ''} // Class để style nếu chưa chọn
                        >
                            {/* Thêm option mặc định */}
                            <option value="" disabled>-- Chọn chủ đề --</option>
                            {/* Các chủ đề tiếng Việt */}
                            <option value="Góp ý dự án">Góp ý cho dự án</option>
                            <option value="Hỏi đáp thông tin">Hỏi đáp thông tin</option>
                            <option value="Hợp tác/Ủng hộ">Mong muốn hợp tác/ủng hộ</option>
                            <option value="Khác">Chủ đề khác</option>
                        </select>
                        {/* Thông báo lỗi cho trường 'subject' */}
                        {/* Cần đảm bảo rule 'required' hoạt động đúng với option mặc định value="" */}
                        {validator.message('subject', forms.subject, 'required')}
                    </div>
                </div>
                <div className="col col-lg-12 col-12">
                    <textarea
                        value={forms.message}
                        onBlur={changeHandler}
                        onChange={changeHandler}
                        name="message"
                        placeholder="Lời nhắn của bạn..." // Đã đổi sang tiếng Việt
                    >
                    </textarea>
                    {/* Thông báo lỗi cho trường 'message' */}
                    {validator.message('message', forms.message, 'required')}
                </div>
            </div>
            <div className="submit-area">
                <button type="submit" className="theme-btn">Gửi Ngay</button> {/* Đã đổi sang tiếng Việt */}
            </div>
        </form>
    )
}

export default ContactForm;